'use strict';

angular.module('ntmApp').factory('QCCheckActivitiesViewModel', ['$q', 'DailyPlanService', 'DailyPlanResourcePool', 'FlashService', 'Utils', 'DailyPlanConfirmationService',
                                 'DragStaffIntoResourcePool', 'DraggingToResourcePoolActions', 'DragFromRPToQCActivities', 'Constants', 'NonDailyActivities', 'ElementIdHelper',
    function ($q, DailyPlanService, DailyPlanResourcePool, FlashService, Utils, DailyPlanConfirmationService,
              DragStaffIntoResourcePool, DraggingToResourcePoolActions, DragFromRPToQCActivities, Constants, NonDailyActivities, ElementIdHelper) {

        function QCCheckActivitiesViewModel(context) {

            var self = this;

            var ConversionFactor = {
                seconds: 1 / 60,
                minutes: 1,
                hours: 60
            };

            self.activityType = Constants.ActivityTypes;

            var FacilityActivityChangedProperty = {
                metricDuration: function (activity, value) {

                    var conversionFactor = ConversionFactor[activity.durationUnit || 'minutes'];
                    if (conversionFactor !== undefined) {
                        activity.totalDuration = parseFloat((parseFloat(value) * activity.quantity * conversionFactor));
                    }
                },
                totalDuration: function (activity, value) {

                    var conversionFactor = ConversionFactor[activity.durationUnit || 'minutes'];

                    if (conversionFactor !== undefined) {
                        activity.metricDuration = activity.quantity > 0 ? parseFloat((parseFloat(value) / (activity.quantity * conversionFactor))) : parseFloat(0);
                    }
                }
            };

            self.showUnplanedActivitiesButton = function (button) {


                if (!button.jsonProperties || !button.jsonProperties.display) {
                    return true;
                }

                return button.jsonProperties.display.level2;
            };

            var AreaActivityChangedProperty = {
                metricDuration: function (activity, value) {

                    var conversionFactor = ConversionFactor[activity.durationUnit || 'minutes'];
                    if (conversionFactor !== undefined) {
                        activity.totalDuration = parseFloat((parseFloat(value) * activity.quantity * conversionFactor));
                    }
                },
                totalDuration: function (activity, value) {

                    var conversionFactor = ConversionFactor[activity.durationUnit || 'minutes'];

                    if (conversionFactor !== undefined) {
                        activity.metricDuration = activity.quantity > 0 ? parseFloat((parseFloat(value) / (activity.quantity * conversionFactor))) : parseFloat(0);
                    }
                }
            };



            self.RowActions = {
                cancelActivity: { value: 1, name: 'Cancel Activity', icon: 'Grid-Setup-Delete-Selectedui-24px-outline.svg' }
            };

            self.load = function (doNotReload) {
                self.isLoading = true;

                loadQCActivities().then(function () {
                    self.isLoading = false;
                });

                if (!doNotReload) {
                    loadStatistics();
                    self.ResourcePool.load();
                    self.NonDailyActivities.load();
                }
            };

            self.hasQCActivities = function () {

                if (self.qcActivities) {
                    return ((self.qcActivities.activities && self.qcActivities.activities[0] && self.qcActivities.activities.length > 0));
                }

                return false;
            };

            self.isChanged = function () {
                return isActivitiesGridChanged();
            };

            self.toggleStatistics = function () {
                self.showStatistics = !self.showStatistics;
                self.showResourcePool = false;
                self.showNonDailyActivities = false;

                saveRightPanesState();
            };

            self.toggleResourcePool = function () {
                self.showResourcePool = !self.showResourcePool;
                self.showStatistics = false;
                self.showNonDailyActivities = false;

                saveRightPanesState();
            };

            self.toggleNonDailyActivities = function () {
                self.showNonDailyActivities = !self.showNonDailyActivities;
                self.showStatistics = false;
                self.showResourcePool = false;

                saveRightPanesState();
            };

            self.isRightPanelOpened = function () {
                return self.showStatistics || self.showResourcePool || self.showNonDailyActivities;
            };

            self.editQCActivities = function () {
                setEditMode();
            };

            self.showRoomActivities = function (record) {

                var request = context.getViewModeAndSelectedDate();
                request.roomNumber = record.roomNumber;
                request.facilityCode = record.facilityCode.trim();

                var loadingModal = FlashService.Loading();
                DailyPlanService.GetRoomActivities(request).then(function (result) {

                    var data = {
                        isCurrentDateDisplayed: context.TopBar.isCurrentDateDisplayed(),
                        room: record.roomNumber,
                        activities: result.data.roomActivityGroups,
                        activityType: Constants.ActivityTypes,
                        getTotalDurationOfGroup: function (roomActivity) {
                            return roomActivity.items ? roomActivity.items.sumOf('totalDuration') : 0;
                        },
                        getTotalDuration: function (groups) {
                            var sum = 0;

                            if (groups) {
                                groups.forEach(function (group) {
                                    sum += group.items ? group.items.sumOf('totalDuration') : 0;
                                });
                            }

                            return sum;
                        },

                        getUnAssignedDuration: function (groups) {
                            var sum = 0;

                            if (groups) {
                                groups.forEach(function (group) {
                                    sum += group.items ? group.items.filter(function (item) {
                                        return !item.assignment;
                                    }).sumOf('totalDuration') : 0;
                                });
                            }

                            return sum;
                        },
                        getGroupStatus: function (group) {

                            var byGroupStatus = group.items.groupBy('activityStatusId');

                            if (context.TopBar.isPastDateDisplayed()) {

                                if (byGroupStatus.length > 1) {
                                    return context.TopBar.activityStatuses[4].value;
                                } else {

                                    if (byGroupStatus[0].key === context.TopBar.activityStatuses[2].id) {
                                        return context.TopBar.activityStatuses[2].value;
                                    } else {
                                        return context.TopBar.activityStatuses[4].value;
                                    }
                                }
                            } else {

                                if (byGroupStatus.length > 1) {
                                    return context.TopBar.activityStatuses[1].value;
                                } else {

                                    if (byGroupStatus[0].key === context.TopBar.activityStatuses[0].id) {
                                        return context.TopBar.activityStatuses[0].value;
                                    } else if (byGroupStatus[0].key === context.TopBar.activityStatuses[2].id) {
                                        return context.TopBar.activityStatuses[2].value;
                                    } else {
                                        return group.items[0].status;
                                    }
                                }
                            }
                        },
                        getGroupIcon: function (group) {

                            var byGroupStatus = group.items.groupBy('activityStatusId');

                            if (context.TopBar.isPastDateDisplayed()) {

                                if (byGroupStatus.length > 1) {
                                    return context.TopBar.activityStatuses[4].icon;
                                } else {

                                    if (byGroupStatus[0].key === context.TopBar.activityStatuses[2].id) {
                                        return context.TopBar.activityStatuses[2].icon;
                                    } else {
                                        return context.TopBar.activityStatuses[4].icon;
                                    }
                                }
                            } else {

                                if (byGroupStatus.length > 1) {
                                    return context.TopBar.activityStatuses[1].icon;
                                } else {

                                    if (byGroupStatus[0].key === context.TopBar.activityStatuses[0].id) {
                                        return context.TopBar.activityStatuses[0].icon;
                                    } else if (byGroupStatus[0].key === context.TopBar.activityStatuses[2].id) {
                                        return context.TopBar.activityStatuses[2].icon;
                                    } else {
                                        return group.items[0].statusIcon;
                                    }
                                }
                            }
                        },

                        expandAllDialogRoomActivities: function () {
                            result.data.roomActivityGroups.forEach(function (group) {
                                group.expanded = true;
                            });
                        },

                        collapseAllDialogRoomActivities: function () {
                            result.data.roomActivityGroups.forEach(function (group) {
                                group.expanded = false;
                            });
                        },

                        getGroupingStaffSummaries: function (group) {
                            var uniqueIds = Array.from(new Set(group.items.map(function (item) { return item.assignmentId; })));
                            var groupedItems = [];

                            uniqueIds.forEach(function (id) {
                                if (id !== null && id !== undefined) {
                                    groupedItems.push(group.items.filter(function (item) { return item.assignmentId === id; }));
                                }
                            });

                            var groupingSummary = [];

                            groupedItems.forEach(function (groupingItem) {
                                groupingSummary.push({
                                    assigneeId: groupingItem[0].assignmentId ? groupingItem[0].assignmentId : null,
                                    assigneeName: groupingItem[0].assignment ? groupingItem[0].assignment : null,
                                    totalActivityDurations: groupingItem.sumOf('totalDuration')
                                });
                            });

                            return groupingSummary;
                        }
                    };

                    result.data.roomActivityGroups.forEach(function (group) {
                        group.icons = getUniqueIcons(group.items);
                    });

                    loadingModal.dismiss();
                    Utils.OpenModal("", "ng1/src/dailyPlan/views/level2/roomInfo.html", null, data, 'room-activities-dialog', null, false);
                });

            };

            self.getMetricDurationStepValue = function (durationType, getValueType) {

                var spinerStep = 1;
                var roundTo = 1;

                switch (durationType) {
                    case 'seconds':
                        spinerStep = 1;
                        roundTo = 0;
                        break;
                    case 'minutes':
                        spinerStep = 0.1;
                        roundTo = 2;
                        break;
                    case 'hours':
                        spinerStep = 0.01;
                        roundTo = 2;
                        break;

                }

                if (getValueType === 'roundTo') {
                    return roundTo;
                } else if (getValueType === 'spinerStep') {
                    return spinerStep;
                }
            };

            self.totalFacilityActivityMinutes = function (facilityActivity) {

                if (facilityActivity && facilityActivity.items) {
                    return facilityActivity.items.reduce(function (sum, item) {
                        return (sum || 0) + parseFloat(item.totalDuration) || 0;
                    }, 0);
                }

                return 0;
            };

            self.totalAreaActivityMinutes = function (areaActivity) {

                if (areaActivity && areaActivity.items) {
                    return areaActivity.items.reduce(function (sum, item) {
                        return (sum || 0) + parseFloat(item.totalDuration) || 0;
                    }, 0);
                }

                return 0;
            };

            self.facilityActivityChanged = function (activity, group, property) {

                if (angular.isNumber(activity.quantity) && angular.isNumber(parseFloat(activity[property]))) {

                    if (FacilityActivityChangedProperty[property]) {
                        FacilityActivityChangedProperty[property](activity, activity[property]);
                    }

                } else {
                    activity.totalDuration = null;
                }

                group.groupingSummaries = getGroupingStaffSummaries(group);
            };

            self.areaActivityChanged = function (activity, group, property) {

                if (angular.isNumber(activity.quantity) && angular.isNumber(parseFloat(activity[property]))) {

                    if (AreaActivityChangedProperty[property]) {
                        AreaActivityChangedProperty[property](activity, activity[property]);
                    }

                } else {
                    activity.totalDuration = null;
                }

                group.groupingSummaries = getGroupingStaffSummaries(group);
            };

            self.updateViewOnWebSocketsResponse = function (callBackData) {

                var dateDisplayed = moment(context.TopBar.dateDisplayed).startOf('day');
                var socketDate = moment(callBackData.date).startOf('day');

                if (dateDisplayed.isSame(socketDate) && !self.EditMode) {

                    if (context.selectedActivityType && context.selectedActivityType === 'QC Check Activities') {

                        var callbackFacilityMatched = callBackData.dailySocketFacilities.firstOrDefault(function (facility) {
                            return (facility.facilityCode && facility.facilityCode.toString() === context.TopBar.BreadCrumbs.selectedLocation.id.toString());
                        });

                        if (callbackFacilityMatched) {
                            reloadView();
                        }
                    }
                }
            };

            self.confirmViewLeaving = function (nextAction) {

                var saveAndContinue = function () {

                    if (self.EditMode || self.isActivitiesGridChanged()) {
                        self.saveQCActivities(nextAction);
                    }

                };

                var continueWithoutSaving = function () {

                    if (self.EditMode || self.isActivitiesGridChanged()) {
                        self.cancelQCActivitiesDurationChanges(nextAction);
                    }

                };

                DailyPlanConfirmationService.Confirmation(getOnLeaveConfirmMessage())
                                   .Yes(saveAndContinue)
                                   .No(continueWithoutSaving)
                                   .Ask();
            };

            self.getInfoForDraggingAction = function () {
                var scheduleIds = [];
                var schedules = [];
                var targetActivitiesInNewStatusList = [];
                var isExistingAssignments = self.ResourcePool.replaceAssignments || false;
                var activities = [];


                var activitiesGroup = self.qcActivities.activities.firstOrDefault(function (group) {
                    return group.dndTarget && group.dndTarget.length > 0;
                });

                if (activitiesGroup) {

                    if (isExistingAssignments) {
                        activitiesGroup.items.forEach(function (activityItem) {
                            if (self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId)) {
                                scheduleIds.push(activityItem.scheduleId);
                                schedules.push(activityItem);
                                activities.push({ speciesId: activityItem.speciesCode, speciesName: activityItem.speciesName, activityId: activityItem.activityId, activity: activityItem.activity, assignmentId: activityItem.assignmentId, activityStatusId: activityItem.activityStatusId });
                            }
                        });

                        targetActivitiesInNewStatusList = schedules.filter(function (activityItem) {
                            return self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId);
                        });
                    }
                    else {
                        activitiesGroup.items.filter(function (activityItem) {
                            return !activityItem.assignmentId;
                        }).forEach(function (activityItem) {
                            if (self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId)) {
                                scheduleIds.push(activityItem.scheduleId);
                                schedules.push(activityItem);
                                activities.push({ speciesId: activityItem.speciesCode, speciesName: activityItem.speciesName, activityId: activityItem.activityId, activity: activityItem.activity, assignmentId: activityItem.assignmentId, activityStatusId: activityItem.activityStatusId });
                            }
                        });
                    }

                    return {
                        date: moment(context.TopBar.dateDisplayed),
                        scheduleIds: scheduleIds,
                        schedules: schedules,
                        targetActivitiesInNewStatusList: targetActivitiesInNewStatusList.length > 0 ? targetActivitiesInNewStatusList : null,
                        scopeCode: context.TopBar.BreadCrumbs.selectedLocation.id,
                        scopeName: context.TopBar.BreadCrumbs.selectedLocation.name,
                        scopeMode: context.getViewMode(),
                        otherActivityMode: 1,
                        groupCode: activitiesGroup.id,
                        groupName: activitiesGroup.name,
                        isExistingAssignments: self.ResourcePool.replaceAssignments || false,
                        isActivitiesGroup: true,
                        activities: activities
                    };
                }

                var activitiesGroupWithTargetedActivity = self.qcActivities.activities.firstOrDefault(function (group) {
                    return group.items.some(function (item) {
                        return item.dndTarget && item.dndTarget.length > 0;
                    });
                });

                if (activitiesGroupWithTargetedActivity) {

                    var facilityActivity = activitiesGroupWithTargetedActivity.items.firstOrDefault(function (item) {
                        return item.dndTarget && item.dndTarget.length > 0;
                    });

                    if (facilityActivity) {

                        return {
                            facilityCode: context.TopBar.BreadCrumbs.selectedLocation.id,
                            date: moment(context.TopBar.dateDisplayed),
                            scheduleId: facilityActivity.scheduleId,
                            schedule: facilityActivity,
                            activityName: facilityActivity.activity,
                            totalHoursActivitiesRow: facilityActivity.totalHours,
                            isExistingAssignments: self.ResourcePool.replaceAssignments || false,
                            isSingleActivity: true,
                            speciesId: facilityActivity.speciesCode, speciesName: facilityActivity.speciesName, activityId: facilityActivity.activityId, activity: facilityActivity.activity
                        };
                    }
                }

                return {};
            };

            self.saveQCActivities = function (nextAction) {

                var request = context.getViewModeSelectedDateAndLocation();
                request.scheduleDurations = [];

                self.qcActivities.activities.forEach(function (facilityActivity) {

                    var originalGroup = self.qcActivitiesOriginal.activities.firstOrDefault(function (original) {
                        return original.name === facilityActivity.name;
                    });

                    if (originalGroup) {

                        facilityActivity.items.forEach(function (item) {

                            var originalActivity = originalGroup.items.firstOrDefault(function (activity) {
                                return item.scheduleId === activity.scheduleId;
                            });

                            if (originalActivity && item.totalDuration !== originalActivity.totalDuration) {

                                request.scheduleDurations.push({
                                    scheduleId: item.scheduleId,
                                    metricDuration: item.metricDuration,
                                    totalMinutes: item.totalDuration
                                });
                            }
                        });
                    }
                });

                var loadingModal = FlashService.Loading();
                DailyPlanService.SaveRoomActivities(request).then(function (result) {

                    if (result.success) {
                        self.qcActivitiesOriginal = angular.copy(self.qcActivities);
                        setViewMode();

                        $q.all([loadQCActivities(), self.ResourcePool.load()])
                          .then(function () {
                              loadingModal.dismiss();

                              if (nextAction) {
                                  nextAction();
                              }

                          });

                        FlashService.Success(result.data.message);
                    } else {
                        loadingModal.dismiss();
                    }
                });

            };

            self.cancelQCActivitiesDurationChanges = function (nextAction) {

                var cancelQCActivitiesDurationChangesAction = function () {

                    self.qcActivities.activities.forEach(function (group) {

                        var originalGroup = self.qcActivitiesOriginal.activities.firstOrDefault(function (original) {
                            return original.name === group.name;
                        });

                        if (originalGroup) {

                            group.items.forEach(function (activity) {

                                var originalActivity = originalGroup.items.firstOrDefault(function (item) {
                                    return item.scheduleId === activity.scheduleId;
                                });

                                if (originalActivity && activity.totalDuration !== originalActivity.totalDuration) {
                                    activity.totalDuration = originalActivity.totalDuration;
                                }
                            });

                            group.groupingSummaries = getGroupingStaffSummaries(group);
                        }
                    });

                    setViewMode();

                    if (nextAction) {
                        nextAction();
                    }

                };

               
                cancelQCActivitiesDurationChangesAction();
                setViewMode();
        

            };

            self.resetQCActivitiesDurationChanges = function (type) {

                var request = context.getViewModeSelectedDateAndLocation();
                request.scheduleIds = [];

                self.qcActivities.activities.forEach(function (facilityActivityGroup) {

                    facilityActivityGroup.items.forEach(function (item) {
                        request.scheduleIds.push(item.scheduleId);
                    });
                });

                request.activityResetAction = type;

                var loadingModal = FlashService.Loading();
                DailyPlanService.ResetLocationActivities(request).then(function () {
                    reloadView(loadingModal);
                });
            };

            self.processGridRowAction = function (action, item) {
                var data = {};
                data.activityActionType = action.value;
                data.scheduleIds = [item.scheduleId];
                //data.facilityCode = item.facilityCode.trim();
                data.date = moment(context.TopBar.dateDisplayed).startOf('day');
                //activity Type==Other activity
                data.activityType = 1;
                var sendGridRowAction = function () {

                    var loadingModal = FlashService.Loading();
                    DailyPlanService.SetGridRowActions(data).then(function (result) {

                        $q.all([loadQCActivities(), self.ResourcePool.load()])
                          .then(function () {
                              loadingModal.dismiss();
                          });

                        FlashService.Success(result.data.message);
                    }).finally(function () {
                        loadingModal.dismiss();
                    });
                };

                switch (action.name) {
                    case 'Cancel Activity':
                        var confirmationMessage = self.doesActivityStatusAllowActivityChanging(item.activityStatusId) ? "Are you sure you want to cancel this activity?" : "This activity has already been marked " + item.activityStatus + ". Are you sure you want to cancel this activity?";

                        DailyPlanConfirmationService.YesNoConfirmation(confirmationMessage, null, { title: 'Cancel Activity', no: 'Never mind', yes: 'Yes, Cancel Activity' })
                                   .Yes(sendGridRowAction)
                                   .Ask();

                        break;
                }
            };

            self.isThereNoActivities = function () {
                return !self.qcActivities || (!self.qcActivities.activities ||
                         self.qcActivities.activities.length === 0 ||
                         self.qcActivities.activities[0].items.length === 0);
            };

            self.showCancelledActivitiesDialog = function (cancelledActivities) {

                var data = {
                    cancelledActivities: cancelledActivities,
                    date: moment(context.TopBar.dateDisplayed).startOf('day'),
                    isPastDateDisplayed: context.TopBar.isPastDateDisplayed()
                };

                var popup = Utils.OpenModal('', 'ng1/src/dailyPlan/views/dialogs/cancelledActivitiesDialog.html', 'cancelledActivitiesController', data, 'daily-plan-cancelled-activities-dialog', null, false);

                popup.result.then(function (reload) {
                    if (reload) {
                        var loadingModal = FlashService.Loading();
                        $q.all([loadQCActivities(), self.ResourcePool.load()])
                            .then(function () {
                                loadingModal.dismiss();
                            });
                    }

                    popup.dismiss();
                });
            };

            self.defaultDndTargets = function () {
                self.ResourcePool.dndTarget = [];

                if (self.qcActivities.activities) {
                    self.qcActivities.activities.forEach(function (group) {
                        group.dndTarget = [];

                        if (group.items) {
                            group.items.forEach(function (item) {
                                if (self.doesActivityStatusAllowActivityChanging(item.activityStatusId)) {
                                    item.dndTarget = [];
                                    item.dndType = group.name;
                                }
                            });
                        }
                    });
                }
            };

            self.filterPresentStaffByRoomSpecies = function (activity) {

                self.ResourcePool.Filter.ByActivityFilter.selectedItems = self.ResourcePool.Filter.ByActivityFilter.selectedItems.filter(m => m.id !== activity.activityId);
                self.ResourcePool.Filter.ByActivityFilter.selectedItems.push({ id: activity.activityId, value: activity.activity });

                if (!self.showResourcePool) {
                    self.toggleResourcePool();
                }

                self.ResourcePool.performFiltering();
            };

            self.doesActivityStatusAllowActivityChanging = function (activityStatusId) {
                return activityStatusId === Constants.ActivityStatus.NotStarted || activityStatusId === Constants.ActivityStatus.Lapsed;
            };

            self.openStaffNoteEditing = function (activity, groupName) {

                var data = {
                    selectedActivity: activity,
                    groupName: groupName
                };

                Utils.OpenModal('', 'ng1/src/dailyPlan/views/dialogs/staffNotesDialog.html', 'staffNotesController', data, 'staff-notes-dialog', null, false);
            };

            function getOnLeaveConfirmMessage() {

                if (self.EditMode || self.isActivitiesGridChanged()) {
                    return "Save pending duration changes?";
                }

                return "";
            }

            function isActivitiesGridChanged() {

                if (self.qcActivities && self.qcActivities.activities) {

                    return self.qcActivities.activities.some(function (group) {

                        var originalGroup = self.qcActivitiesOriginal.activities.firstOrDefault(function (original) {
                            return original.name === group.name;
                        });

                        if (originalGroup) {

                            return group.items.some(function (activity) {

                                var originalActivity = originalGroup.items.firstOrDefault(function (item) {
                                    return item.scheduleId === activity.scheduleId;
                                });

                                if (originalActivity) {
                                    return activity.totalDuration !== originalActivity.totalDuration;
                                }

                                return false;
                            });
                        }

                        return false;
                    });
                }

                return false;
            }

            function saveRightPanesState() {
                sessionStorage.showDailyPlanResourcePoolPane = self.showResourcePool || "";
                sessionStorage.showDailyPlanNonDailyActivitiesPane = self.showNonDailyActivities || "";
                sessionStorage.showDailyPlanStatisticsPane = "";
            }

            function setViewMode() {
                self.EditMode = false;
            }

            function setEditMode() {
                self.EditMode = true;
            }

            function getGroupingStaffSummaries(group) {
                var uniqueIds = Array.from(new Set(group.items.map(function (item) { return item.assignmentId; })));
                var groupedItems = [];

                uniqueIds.forEach(function (id) {
                    if (id !== null && id !== undefined) {
                        groupedItems.push(group.items.filter(function (item) { return item.assignmentId === id; }));
                    }
                });

                var groupingSummary = [];

                groupedItems.forEach(function (groupingItem) {
                    groupingSummary.push({
                        assigneeId: groupingItem[0].assignmentId ? groupingItem[0].assignmentId : null,
                        assigneeName: groupingItem[0].assignment ? groupingItem[0].assignment : null,
                        totalActivityDurations: groupingItem.sumOf('totalDuration'),
                        hasChangeableActivities: (groupingItem.filter(function (item) { return self.doesActivityStatusAllowActivityChanging(item.activityStatusId); }).length > 0) ? true : false
                    });
                });

                return groupingSummary;
            }

            function loadStatistics() {

                var deferred = $q.defer();
                var request = context.getViewModeSelectedDateAndLocation();

                self.statisticChanging = true;
                DailyPlanService.GetDetailsStatistics(request).then(function (result) {

                    if (result.success) {
                        self.statistic = result.data;
                    }

                    self.statisticChanging = false;
                    deferred.resolve();
                });

                return deferred.promise;
            }

            function reloadView(loadingModal) {

                loadingModal = loadingModal || FlashService.Loading();

                $q.all([loadQCActivities(), self.ResourcePool.load()])
                  .then(function () {
                      loadingModal.dismiss();
                  });

                self.NonDailyActivities.load();
            }

            function getUniqueIcons(activities) {

                var icons = activities.filter(function (activity) {
                    return activity.activityIcon;
                }).map(function (activity) {
                    return {
                        icon: Constants.ActivityTypes.getIconSrc(activity),
                        color: Constants.ActivityTypes.getIconColor(activity.activityIcon)
                    };
                }).unique(function (icon1, icon2) {
                    return icon1.icon === icon2.icon &&
                           icon1.color === icon2.color;
                });

                return icons;
            }

            function loadQCActivities() {

                var deferred = $q.defer();
                var request = context.getViewModeSelectedDateAndLocation();

                DailyPlanService.GetQCCheckActivities(request).then(function (result) {

                    if (result.success) {

                        result.data.qcActivities = [{
                            id: 'QC Activities',
                            items: result.data.qcActivities,
                            name: 'QC Activities'
                        }];

                        self.qcActivities = {
                            activities: result.data.qcActivities,
                            cancelledQCActivities: result.data.cancelledQcActivities
                        };

                        self.qcActivities.activities.forEach(function (group) {

                            group.items.forEach(function (activity) {
                                activity.elementClassName = ElementIdHelper.getActivityElementClassName(activity.scheduleId, activity.activityStatusId);
                            });

                            group.hasChangeableActivities = (group.items.filter(function (item) { return self.doesActivityStatusAllowActivityChanging(item.activityStatusId); }).length > 0) ? true : false;
                            group.groupingSummaries = getGroupingStaffSummaries(group);
                            group.expanded = true;
                        });

                        
                        self.defaultDndTargets();

                        self.qcActivities.activities.hasChangeableActivities = (self.qcActivities.activities.filter(function (group) { return group.hasChangeableActivities === true; }).length > 0) ? true : false;

                        self.qcActivitiesOriginal = angular.copy(self.qcActivities);
                    }

                    deferred.resolve();
                });

                return deferred.promise;
            }

            function isDraggingAllowed() {

                if (self.EditMode) {
                    FlashService.Error('Please save or cancel duration changes before changing assignments.');
                    return false;
                }

                return true;
            }

            function onEndDragging() {

                if (SignalR.IsSupported()) {
                    self.defaultDndTargets();
                } else {
                    reloadView();
                }
            }

            function initialize() {
                self.ResourcePool = new DailyPlanResourcePool(context);
                self.NonDailyActivities = new NonDailyActivities(context);
                self.DragFromResourcePool = new DragFromRPToQCActivities(self);
                self.DragFromResourcePool.onStartDragging(function () {
                    return isDraggingAllowed();
                });

                self.DragFromResourcePool.onEndDragging(onEndDragging);

                self.DragStaffIntoResourcePool = new DragStaffIntoResourcePool(context);

                self.DragToResourcePool = new DraggingToResourcePoolActions([self.DragStaffIntoResourcePool]);
                self.DragToResourcePool.onEndDragging(onEndDragging);
                self.DragToResourcePool.onStartDragging(function () {

                    if (isDraggingAllowed()) {

                        if (!self.showResourcePool) {
                            self.toggleResourcePool();
                        }

                        self.ResourcePool.selectPresentStaffTab();

                        return true;
                    }

                    return false;
                });

                self.EditMode = false;

                self.showStatistics = sessionStorage.showDailyPlanStatisticsPane ? true : false;
                self.showResourcePool = sessionStorage.showDailyPlanResourcePoolPane ? true : false;
                self.showNonDailyActivities = sessionStorage.showDailyPlanNonDailyActivitiesPane ? true : false;

                if (self.showStatistics && self.showResourcePool) {
                    self.showStatistics = false;
                }
                if (self.showNonDailyActivities && self.showResourcePool) {
                    self.showNonDailyActivities = false;
                }
            }

            initialize();
        }

        return (QCCheckActivitiesViewModel);

    }]);
